import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-humanresources',
  templateUrl: './humanresources.component.html',
  styleUrls: ['./humanresources.component.scss']
})
export class HumanresourcesComponent implements OnInit {

  constructor(title:Title) {
    title.setTitle("İnsan Kaynakları | Eti Gümüş A.Ş.");
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/humanresources/humanresources.component.ts